import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmationPage from "@/pages/OrderConfirmationPage";
import PaymentCompletePage from "@/pages/PaymentCompletePage";
import CustomerAuthPage from "@/pages/CustomerAuthPage";
import CustomerProfilePage from "@/pages/CustomerProfilePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ContactsPage from "@/pages/ContactsPage";
import LoyaltyProgramPage from "@/pages/LoyaltyProgramPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrdersUnified from "@/pages/admin/AdminOrdersUnified";
import AdminMagazzino from "@/pages/admin/AdminMagazzino";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminPartnerCompanies from "@/pages/admin/AdminPartnerCompanies";
import AdminDiscountCodes from "@/pages/admin/AdminDiscountCodes";
import AdminDeliveryPage from "@/pages/admin/AdminDeliveryPage";
import AdminScadenze from "@/pages/admin/AdminScadenze";
import AdminPartnerSpending from "@/pages/admin/AdminPartnerSpending";
import AdminQuickOrder from "@/pages/admin/AdminQuickOrder";
import AdminSpecialLists from "@/pages/admin/AdminSpecialLists";
import AdminComuni from "@/pages/admin/AdminComuni";
import SpecialListPage from "@/pages/SpecialListPage";
import { CartProvider } from "@/context/CartContext";
import { CustomerProvider } from "@/context/CustomerContext";
import { Toaster } from "@/components/ui/sonner";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <CustomerProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalogo" element={<CatalogPage />} />
              <Route path="/catalogo/:categoryId" element={<CatalogPage />} />
              <Route path="/prodotto/:productId" element={<ProductDetailPage />} />
              <Route path="/carrello" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/conferma-ordine/:orderId" element={<OrderConfirmationPage />} />
              <Route path="/pagamento-completato" element={<PaymentCompletePage />} />
              <Route path="/accedi" element={<CustomerAuthPage />} />
              <Route path="/profilo" element={<CustomerProfilePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/contatti" element={<ContactsPage />} />
              <Route path="/programma-fedelta" element={<LoyaltyProgramPage />} />
              
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/categorie" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
              <Route path="/admin/prodotti" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
              <Route path="/admin/ordini" element={<ProtectedRoute><AdminOrdersUnified /></ProtectedRoute>} />
              <Route path="/admin/magazzino" element={<ProtectedRoute><AdminMagazzino /></ProtectedRoute>} />
              <Route path="/admin/scadenze" element={<ProtectedRoute><AdminScadenze /></ProtectedRoute>} />
              <Route path="/admin/clienti" element={<ProtectedRoute><AdminCustomers /></ProtectedRoute>} />
              <Route path="/admin/aziende-partner" element={<ProtectedRoute><AdminPartnerCompanies /></ProtectedRoute>} />
              <Route path="/admin/codici-sconto" element={<ProtectedRoute><AdminDiscountCodes /></ProtectedRoute>} />
              <Route path="/admin/disponibilita" element={<ProtectedRoute><AdminDeliveryPage /></ProtectedRoute>} />
              <Route path="/admin/spesa-partner" element={<ProtectedRoute><AdminPartnerSpending /></ProtectedRoute>} />
              <Route path="/admin/ordine-rapido" element={<ProtectedRoute><AdminQuickOrder /></ProtectedRoute>} />
              <Route path="/admin/liste-spesa" element={<ProtectedRoute><AdminSpecialLists /></ProtectedRoute>} />
              <Route path="/admin/comuni" element={<ProtectedRoute><AdminComuni /></ProtectedRoute>} />
              <Route path="/la-mia-lista" element={<SpecialListPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </CartProvider>
    </CustomerProvider>
  );
}

export default App;
